/**
 * Module dependencies
 */

import { AxiosError } from 'axios';
import { TFunction } from 'i18next';
import camelCase from 'lodash/camelCase';
import isNil from 'lodash/isNil';
import pickBy from 'lodash/pickBy';
import { FieldValues, UseFormSetError } from 'react-hook-form';

/**
 * Export `FormNetworkError` type.
 */

export type FormNetworkError<TFieldValues = FieldValues> = AxiosError<
  Record<'errors', Record<keyof TFieldValues, string[]>>
>;

/**
 * Export `setFormServerErrors` util.
 */

export function setFormServerErrors<TFieldValues = FieldValues>(
  networkError: FormNetworkError<TFieldValues>,
  setError: UseFormSetError<FieldValues>,
  translate: TFunction,
  basePath: string
) {
  const fieldErrors = networkError?.response?.data?.errors;
  const errors = !!fieldErrors && Object.entries(fieldErrors);

  if (errors) {
    errors.forEach(([key, [message]]: any) => {
      setError(key, {
        message: translate(`${basePath}${camelCase(message)}`),
        type: 'server'
      });
    });
  }
}

/**
 * Export `pickNonNil` util.
 *
 * Utility that allows to pick form data that is not `null` or `undefined`.
 */

export function pickNonNil(data: Record<string, unknown> | undefined, keys: string[]) {
  if (!data) {
    return {};
  }

  return pickBy(data, (value, key) => !isNil(value) && keys.includes(key));
}
